import { NgModule } from '@angular/core';
import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { TamasAlunoService } from '../tamas-aluno.service';


@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit, OnDestroy {

  constructor(public tmaService: TamasAlunoService,  public router: Router) { }

  ngOnInit() {
    this.tmaService.eventoFS(true);
    if(!this.tmaService.hcPremium){
      this.router.navigate(['/home']);
    }
  }
  ngOnDestroy(){
    this.tmaService.eventoFS(false);
    
  }

}
